import { render } from "./HistoricCard.vue?vue&type=template&id=0e23bf9a"
import script from "./HistoricCard.vue?vue&type=script&lang=js"
export * from "./HistoricCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__